import { createContext, useEffect, useState } from "react";

export const StoreContext = createContext();

const StoreContextProvider = ({ children }) => {

  // Token State
  const [token, setToken] = useState(
    localStorage.getItem("adminToken") || ""
  );

  // Admin State
  const [admin, setAdmin] = useState(
    JSON.parse(localStorage.getItem("adminData")) || null
  );

  // Auth State
  const [isAuthenticated, setIsAuthenticated] =
    useState(false);

  // Loading State
  const [loading, setLoading] = useState(true);

  // Verify Token On Load
  useEffect(() => {
    if (token) {
      verifyToken(token);
    } else {
      setLoading(false);
    }
  }, [token]);

  // Verify Admin Token
  const verifyToken = async (currentToken) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/admin/verify`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${currentToken}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setIsAuthenticated(true);
        setAdmin(data.admin);
      } else {
        logout();
      }

    } catch (error) {
      console.error("Verification error:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  // Login Function
  const login = (newToken, adminData) => {

    localStorage.setItem("adminToken", newToken);

    localStorage.setItem(
      "adminData",
      JSON.stringify(adminData)
    );

    setToken(newToken);
    setAdmin(adminData);
    setIsAuthenticated(true);
  };

  // Logout Function
  const logout = () => {

    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");

    setToken("");
    setAdmin(null);
    setIsAuthenticated(false);
  };

  // Context Value
  const contextValue = {
    token,
    setToken,

    admin,
    setAdmin,

    isAuthenticated,
    setIsAuthenticated,

    loading,

    login,
    logout,
  };

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreContextProvider;